import Main from '@/components/main/Main';
// 支付模块的路由
export default [
  {
    name: 'dmp_report_main',
    path: '/dmp/report',
    component: Main,
    redirect: '/dmp/report/dmp_report_originality',
    meta: {
      showInMenu: true,
      showAlways: true, // 表示一定要展示子菜单
      title: '数据报表',
      icon: 'md-apps'
    },
    children: [
      {
        name: 'dmp_report_originality',
        path: '/dmp/report/dmp_report_originality',
        component: () => import('@/emc-dmp/views/dmpreport/originality'),
        meta: {
          showInMenu: true,
          path: '/dmp/report/dmp_report_originality',
          title: '广告创意数据',
          icon: 'md-aperture'
        }
      },
      {
        name: 'dmp_report_plan',
        path: '/dmp/report/dmp_report_plan',
        component: () => import('@/emc-dmp/views/dmpreport/plan'),
        meta: {
          showInMenu: true,
          path: '/dmp/report/dmp_report_plan',
          title: '广告计划数据',
          icon: 'md-book'
        }
      }
    ]
  }
];
